exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Bpik{float:left;text-align:center;padding:5px 10px;border-right:.1px solid #4b4b4b}._3Bpik a{width:120px;height:60px;display:block}", ""]);

// exports
exports.locals = {
	"item": "_3Bpik"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/CarouselItem/CarouselItem.css
// module id = 1056
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13